import * as OrderFilter from '../Components/OrderFiltering/Model/OrderFilter'
import * as OrderExportOptions from '../Data/OrderExportOptions'
import {LocalDateTime} from 'js-joda'
import {array, Decoder, field, number, object} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface OrderExport {
    readonly id: number
    readonly manufacturerId: number
    readonly cis2UserId: number
    readonly filters: OrderFilter.OrderFilter[]
    readonly options: OrderExportOptions.OrderExportOptions
    readonly lastAccess: LocalDateTime
    readonly created: LocalDateTime
}

export function orderExportDecoder(): Decoder<OrderExport> {
    return object({
        id: field('id', number()),
        manufacturerId: field('manufacturerId', number()),
        cis2UserId: field('cis2UserId', number()),
        filters: field('filters', array(OrderFilter.decoder())),
        options: field('options', OrderExportOptions.decoder()),
        lastAccess: field('lastAccess', localDateTimeDecoder()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderExport.ts